import { API_ENDPOINTS, API_CONFIG } from '../config/api.config';
import httpService from './http.service';
import documentService from './document.service';
import stepSelectionService from './step-selection.service';
import { responseService } from './response.service';

class DemandeService {
  // Créer une nouvelle demande
  async createDemande(demandeData) {
    try {
      console.log('Création d\'une nouvelle demande:', demandeData);
      console.log('URL de l\'endpoint:', API_ENDPOINTS.DEMANDES.CREATE);
      console.log('URL complète:', `${API_CONFIG.BASE_URL}${API_ENDPOINTS.DEMANDES.CREATE}`);
      
      // Validation des données requises
      const validationResult = this.validateDemandeData(demandeData);
      if (!validationResult.isValid) {
        console.error('Erreurs de validation:', validationResult.errors);
        return {
          success: false,
          error: validationResult.errors.join(', '),
        };
      }

      // Uploader les documents si il y en a
      let documentIds = [];
      if (demandeData.uploadedFiles && demandeData.uploadedFiles.length > 0) {
        console.log('Upload des documents...');
        const uploadResult = await documentService.uploadDocuments(demandeData.uploadedFiles);
        
        if (uploadResult.success) {
          documentIds = uploadResult.data;
          console.log('Documents uploadés avec succès, IDs:', documentIds);
        } else {
          console.error('Erreur lors de l\'upload des documents:', uploadResult.errors);
          return {
            success: false,
            error: 'Erreur lors de l\'upload des documents: ' + uploadResult.errors.join(', '),
          };
        }
      }

      // Formater les données avant envoi
      const formattedData = this.formatDemandeData({
        ...demandeData,
        documents: documentIds, // Utiliser les IDs des documents uploadés
      });
      console.log('Données formatées pour l\'API formattedData:', formattedData);
      console.log('URL de l\'API:', API_ENDPOINTS.DEMANDES.CREATE);
      console.log('Type de données projet:', typeof formattedData.projet);
      console.log('Type de données reponse:', typeof formattedData.reponse);

      // Utiliser les vraies données du formulaire
      console.log('Données formatées pour l\'API:', formattedData);
      
      // Validation supplémentaire des données formatées
      console.log('=== VALIDATION DES DONNÉES FORMATÉES ===');
      const validationErrors = [];
      
      // Vérifier que les champs requis sont des chaînes valides
      const stringFields = ['name', 'email', 'numero_tel', 'adresse', 'project_step'];
      stringFields.forEach(field => {
        if (formattedData[field] && typeof formattedData[field] !== 'string') {
          validationErrors.push(`${field} doit être une chaîne, reçu: ${typeof formattedData[field]}`);
        }
      });
      
      // Vérifier que les champs numériques sont des nombres valides
      const numericFields = ['post_code']; // projet et reponse sont maintenant des UUIDs (strings)
      numericFields.forEach(field => {
        if (formattedData[field] !== null && (isNaN(formattedData[field]) || !Number.isInteger(formattedData[field]))) {
          validationErrors.push(`${field} doit être un entier, reçu: ${formattedData[field]} (${typeof formattedData[field]})`);
        }
      });
      
      // Vérifier que les champs UUID sont des strings valides
      const uuidFields = ['projet', 'reponse'];
      uuidFields.forEach(field => {
        if (formattedData[field] !== null && typeof formattedData[field] !== 'string') {
          validationErrors.push(`${field} doit être une chaîne (UUID), reçu: ${formattedData[field]} (${typeof formattedData[field]})`);
        }
      });
      
      // Vérifier que les champs booléens sont des booléens
      const booleanFields = ['has_technician', 'need_technician'];
      booleanFields.forEach(field => {
        if (formattedData[field] !== null && typeof formattedData[field] !== 'boolean') {
          validationErrors.push(`${field} doit être un booléen, reçu: ${formattedData[field]} (${typeof formattedData[field]})`);
        }
      });
      
      if (validationErrors.length > 0) {
        console.error('Erreurs de validation des données formatées:', validationErrors);
        return {
          success: false,
          error: 'Erreur de formatage des données: ' + validationErrors.join(', '),
        };
      }
      
      console.log('Validation des données réussie');
      console.log('================================');
      
      // Envoyer les vraies données du formulaire
      console.log('=== DONNÉES ENVOYÉES À L\'API ===');
      console.log('Endpoint:', API_ENDPOINTS.DEMANDES.CREATE);
      console.log('Données formatées:', JSON.stringify(formattedData, null, 2));
      console.log('Types des champs:');
      Object.entries(formattedData).forEach(([key, value]) => {
        console.log(`- ${key}: ${typeof value} = ${value}`);
      });
      console.log('================================');
      
      // ÉTAPE 1: Créer la demande d'abord (sans l'ID de réponse)
      // On retire temporairement `reponse` pour ne pas envoyer de valeur `null` si l'API est stricte
      const { reponse, ...demandePayload } = formattedData;
      console.log('=== CRÉATION DE LA DEMANDE (SANS RÉPONSES) ===');
      console.log('Données de la demande:', demandePayload);
      
      const demandeResponse = await httpService.post(API_ENDPOINTS.DEMANDES.CREATE, demandePayload);
      const demandeId = demandeResponse.id;
      console.log('Demande créée avec succès, ID:', demandeId);

      // ÉTAPE 2: Créer les réponses en les liant à la demande
      if (demandeData.selectedElements && demandeData.selectedElements.length > 0) {
        console.log('=== CRÉATION DES RÉPONSES ===');
        console.log('Éléments sélectionnés:', demandeData.selectedElements);
        
        try {
          // Formater les sélections en réponses et ajouter l'ID de la demande
          const responsesToCreate = responseService.formatSelectionsAsResponses(demandeData.selectedElements).map(r => ({ ...r, demande: demandeId }));
          
          console.log('Création de', responsesToCreate.length, 'réponses...');
          console.log('Réponses formatées avec ID de demande:', responsesToCreate);

          // Créer les réponses
          const createdResponses = await responseService.createResponses(responsesToCreate);
          console.log('Réponses créées et liées avec succès:', createdResponses);
        } catch (responseError) {
          console.warn('Erreur lors de la création des réponses:', responseError);
          // Ne pas faire échouer la demande principale si les réponses échouent
        }
        } else {
        console.log('Aucune réponse à créer');
      }

      return {
        success: true,
        data: demandeResponse,
      };
    } catch (error) {
      console.error('Erreur lors de la création de la demande:', error);
      console.error('Détails de l\'erreur:', {
        message: error.message,
        status: error.status,
        url: error.url,
        response: error.response
      });
      
      // Si c'est une erreur 400, essayer d'afficher plus de détails
      if (error.status === 400) {
        console.error('Erreur 400 - Données invalides:');
        if (error.response) {
          console.error('Réponse de l\'API:', error.response);
          if (error.response.data) {
            console.error('Données de l\'erreur:', error.response.data);
          }
        }
      }
      
      return {
        success: false,
        error: error.message || 'Erreur lors de la création de la demande',
      };
    }
  }

  // Récupérer la liste des demandes
  async getDemandes(params = {}) {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const endpoint = `${API_ENDPOINTS.DEMANDES.LIST}${queryParams ? `?${queryParams}` : ''}`;
      
      const response = await httpService.get(endpoint);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error('Erreur lors de la récupération des demandes:', error);
      return {
        success: false,
        error: error.message,
      };
    }
  }

  // Récupérer une demande par ID
  async getDemandeById(demandeId) {
    try {
      const response = await httpService.get(API_ENDPOINTS.DEMANDES.DETAIL(demandeId));
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error(`Erreur lors de la récupération de la demande ${demandeId}:`, error);
      return {
        success: false,
        error: error.message,
      };
    }
  }

  // Valider les données de la demande
  validateDemandeData(data) {
    const errors = [];
    
    // Validation des champs requis
    if (!data.name || data.name.trim() === '') {
      errors.push('Le nom est requis');
    }
    
    if (!data.email || data.email.trim() === '') {
      errors.push('L\'email est requis');
    }
    
    if (!data.numero_tel || data.numero_tel.trim() === '') {
      errors.push('Le numéro de téléphone est requis');
    }
    
    if (!data.adresse || data.adresse.trim() === '') {
      errors.push('L\'adresse du chantier est requise');
    }
    
    if (!data.project_step || data.project_step.trim() === '') {
      errors.push('L\'étape du projet est requise');
    }
    
    // Validation des champs personnels
    if (data.name && data.name.length > 255) {
      errors.push('Le nom ne peut pas dépasser 255 caractères');
    }
    
    if (data.numero_tel && data.numero_tel.length > 255) {
      errors.push('Le numéro de téléphone ne peut pas dépasser 255 caractères');
    }
    
    if (data.email && data.email.length > 255) {
      errors.push('L\'email ne peut pas dépasser 255 caractères');
    }
    
    if (data.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
      errors.push('L\'email doit être au format valide');
    }
    
    // Validation des champs du projet
    if (data.adresse && data.adresse.length > 255) {
      errors.push('L\'adresse ne peut pas dépasser 255 caractères');
    }
    
    if (data.reference_chantier && data.reference_chantier.length > 100) {
      errors.push('La référence du chantier ne peut pas dépasser 100 caractères');
    }
    
    if (data.post_code && (data.post_code < -2147483648 || data.post_code > 2147483647)) {
      errors.push('Le code postal doit être un entier valide');
    }
    
    if (data.project_step && data.project_step.length > 255) {
      errors.push('L\'étape du projet ne peut pas dépasser 255 caractères');
    }
    
    if (data.construction_site_ref && data.construction_site_ref.length > 20) {
      errors.push('La référence du site de construction ne peut pas dépasser 20 caractères');
    }
    
    // Validation du format de date
    if (data.project_start_date) {
      const date = new Date(data.project_start_date);
      if (isNaN(date.getTime())) {
        errors.push('La date de début du projet doit être au format valide');
      }
    }
    
    // Validation des documents
    if (data.documents && !Array.isArray(data.documents)) {
      errors.push('Les documents doivent être un tableau');
    }
    
    return {
      isValid: errors.length === 0,
      errors,
    };
  }

  // Formater les données pour l'API
  formatDemandeData(formData) {
    console.log('=== FORMATAGE DES DONNÉES ===');
    console.log('Données d\'entrée:', formData);
    console.log('Type de reference_chantier:', typeof formData.reference_chantier, formData.reference_chantier);
    console.log('IsArray reference_chantier:', Array.isArray(formData.reference_chantier));
    console.log('Valeur reference_chantier avant nettoyage:', formData.reference_chantier);
    console.log('selectedElements reçus:', formData.selectedElements);
    console.log('Nombre de selectedElements:', formData.selectedElements ? formData.selectedElements.length : 0);
    
    // Fonction pour nettoyer les valeurs (convertir les tableaux en chaînes si nécessaire)
    const cleanValue = (value, maxLength = null) => {
      console.log(`Nettoyage de la valeur:`, value, `(type: ${typeof value}, isArray: ${Array.isArray(value)})`);
      
      if (value === null || value === undefined) return null;
      
      // Si c'est un tableau, prendre le premier élément ou joindre les éléments
      if (Array.isArray(value)) {
        console.log(`Conversion du tableau:`, value);
        if (value.length === 0) return null;
        if (value.length === 1) {
          value = value[0];
          console.log(`Premier élément du tableau:`, value);
        } else {
          value = value.join(', ');
          console.log(`Tableau joint:`, value);
        }
      }
      
      // Convertir en chaîne et nettoyer
      const stringValue = String(value).trim();
      console.log(`Valeur finale nettoyée:`, stringValue);
      
      // Appliquer la limite de longueur si spécifiée
      if (maxLength && stringValue.length > maxLength) {
        return stringValue.substring(0, maxLength);
      }
      
      return stringValue || null;
    };

    const formattedData = {
      // Données personnelles - selon le nouveau modèle Demande
      name: cleanValue(formData.name, 255),
      numero_tel: cleanValue(formData.numero_tel, 255), 
      email: cleanValue(formData.email, 255),
      
      // Données du projet - selon le nouveau modèle Demande
      projet: formData.projet || null,
      reponse: formData.reponse ? formData.reponse : null,
      adresse: cleanValue(formData.adresse, 255),
      reference_chantier: cleanValue(formData.reference_chantier, 100),
      post_code: formData.post_code ? parseInt(formData.post_code) : null,
      project_step: cleanValue(formData.project_step, 255),
      project_start_date: formData.project_start_date || null,
      construction_site_ref: cleanValue(formData.construction_site_ref, 20),
      has_technician: Boolean(formData.has_technician),
      need_technician: Boolean(formData.need_technician),
      complementary_info: cleanValue(formData.complementary_info),
      // Le champ documents est bien attendu par le backend pour lier les fichiers
      documents: Array.isArray(formData.documents) ? formData.documents : [],
    };

    // Nettoyer les données : supprimer les propriétés undefined
    Object.keys(formattedData).forEach(key => {
      if (formattedData[key] === undefined) {
        delete formattedData[key];
      }
    });

    // Log détaillé pour déboguer
    console.log('=== DONNÉES FINALES AVANT ENVOI ===');
    console.log('projet type:', typeof formattedData.projet);
    console.log('projet value:', formattedData.projet);
    console.log('projet isArray:', Array.isArray(formattedData.projet));
    console.log('Données complètes:', JSON.stringify(formattedData, null, 2));

    console.log('Données formatées pour l\'API:', formattedData);
    console.log('URL de l\'API:', API_ENDPOINTS.DEMANDES.CREATE);
    console.log('Validation des types:');
    console.log('- projet:', typeof formattedData.projet, formattedData.projet);
    console.log('- reponse:', typeof formattedData.reponse, formattedData.reponse);
    console.log('- post_code:', typeof formattedData.post_code, formattedData.post_code);
    console.log('- has_technician:', typeof formattedData.has_technician, formattedData.has_technician);
    console.log('- need_technician:', typeof formattedData.need_technician, formattedData.need_technician);
    
    return formattedData;
  }
}

// Instance singleton
export const demandeService = new DemandeService();
export default demandeService;